<template>
  <div class="state">
    <div class="bannder">
      <img src="@/assets/shiyongshuoming.png" alt />
    </div>
    <div class="container" v-if="visible">
      <img src="@/assets/aa.png" alt style="width:100%;margin-top:60px" />
    </div>
    <div class="container container2">
      <router-view />
      <div class="page-header" v-if="visible">
        <h1 class="pageh1">使用说明</h1>
        <div class="row">
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">如何发送公众号模版消息？</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  很多人都知道微信公众号除了固定的群发次数外，微信服务号还能够通过模
                  板消息功能来打破这个限制，但是却不知道微信公众号开通了模板消息后如
                  何推送，因为在公众号后台找个了遍都没找到推送功能，那么开通了模板...
                </p>
                <h4 class="chakan" @click="openshow(1)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">微信公众号如何生成追踪来源的二维码？</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  微信公众号怎么生成能追踪来源的渠道二维码？很多商家在做广告活动推广
                  自己的微信公众号时往往苦于不知道渠道来源，比如有家蛋糕店在周围各个
                  小区电梯里都张贴了自己的宣传海报，但是对于各个小区的吸粉情况却一...
                </p>
                <h4 class="chakan" @click="openshow(2)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">如何使用粉丝海报？</div>
              <div class="panel-body panel-body2">
                <p
                  class="over"
                >粉丝海报功能是使用率非常高的一个推广功能，为了满足用户的更多需求，我们推出了粉丝海报。粉丝海报易推广原因分析：每个粉丝的朋友圈人数少则几百多则几千，即使不是企业的粉丝，也能看到企业的活动或是产品的介绍，可谓是对公司品牌的裂变式宣传。企业更是能在后台看到每个粉丝的推广效</p>
                <h4 class="chakan" @click="openshow(3)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">怎么样统计粉丝来源渠道？</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  怎么统计公众号粉丝来源渠道？微信公众号现在已经成为很多企业主流的推
                  广宣传的工具，为了扩大自身影响力、提高粉丝转化，大家把大量精力投入
                  到了公众号的运营中，但是预期的效果并没有达到。究其原因是粉丝来源...
                </p>
                <h4 class="chakan" @click="openshow(4)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">如何使用公众号渠道二维码？</div>
              <div class="panel-body panel-body2">
                <p
                  class="over"
                >客户问题：我们公司主要是卖油漆，下面有很多的销售，我们公司想接入一个 系统，吸粉，然后帮我们品牌多宣传，提高销售转化率。那我们该如何解决...</p>
                <h4 class="chakan" @click="openshow(5)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">如何同步汇客软件模版消息?</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  怎样同步汇客软件模板消息?同步汇客模板消息需要满足2个条件：首先，该
                  公众号是认证服务号，并且在公众号后台申请开通了模板消息功能；其次，
                  需要开通汇客软件账号，并将该公众号绑定汇客软件，在汇客软件公众号...
                </p>
                <h4 class="chakan" @click="openshow(6)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">拼红包功能简介</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  拼红包功能需要公众号已开通微信支付后才可以对接使用。红包参与者可以
                  创建抢红包队伍，并将红包活动页面转发给好友集结队伍。每位加入的好友
                  随机获得手气分，队伍总分达到商家设置的红包人气分级别要求，队伍成...
                </p>
                <h4 class="chakan" @click="openshow(7)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">分享助力简介</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  分享助力又名微信助力活动，常被称为微助力活动，参与分享助力活动的微
                  信粉丝必须通过好友的帮助才可以获得助力值，并通助力值的高低来进行排
                  名排行，商家可以通过对排行榜来进行相关奖品赠送发放。微信分享助力...
                </p>
                <h4 class="chakan" @click="openshow(8)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">拼团购简介</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  拼团购是目前微信圈最火爆的团购交易模块，支持粉丝组团购买，不同人数
                  不同折扣，组团失败支持一键自动退款到用户微信钱包内。可以设置多种团
                  购折扣组合方式，用户可自由选择参团或者开团，粉丝可根据自己需要的...
                </p>
                <h4 class="chakan" @click="openshow(9)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading">到店红包简介</div>
              <div class="panel-body panel-body2">
                <p class="over">
                  全新到店引流利器到店红包功能全新
                  推出，到店红包功能是目前流行的O2O
                  线下门店引爆客流的互动红包功能。到店红包功能只允
                  许认证服务号并已开
                  通微信支付，同时配置好微信支付和支付证书，商户平台内留有足够金额...
                </p>
                <h4 class="chakan" @click="openshow(10)">查看详情&nbsp;>></h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "aa",
  data () {
    return {
      visible: true
    };
  },
  created () {
    if (this.$router.currentRoute.path !== "/state") {
      this.visible = false
    }
  },

  methods: {
    openshow (index) {
      this.index = index;
      // if (index === 1) {
      //   window.open("http://localhost:8081/state/A");
      // } else if (index === 2) {
      //   window.open("http://localhost:8081/state/B");
      // } else if (index === 3) {
      //   window.open("http://localhost:8081/state/C");
      // } else if (index === 4) {
      //   window.open("http://localhost:8081/state/D");
      // } else if (index === 5) {
      //   window.open("http://localhost:8081/state/E");
      // } else if (index === 6) {
      //   window.open("http://localhost:8081/state/F");
      // } else if (index === 7) {
      //   window.open("http://localhost:8081/state/G");
      // } else if (index === 8) {
      //   window.open("http://localhost:8081/state/H");
      // } else if (index === 9) {
      //   window.open("http://localhost:8081/state/I");
      // } else if (index === 10) {
      //   window.open("http://localhost:8081/state/J");
      // }
      if (index === 1) {
        window.open("http://gathercloudsaas.com/state/A");
      } else if (index === 2) {
        window.open("http://gathercloudsaas.com/state/B");
      } else if (index === 3) {
        window.open("http://gathercloudsaas.com/state/C");
      } else if (index === 4) {
        window.open("http://gathercloudsaas.com/state/D");
      } else if (index === 5) {
        window.open("http://gathercloudsaas.com/state/E");
      } else if (index === 6) {
        window.open("http://gathercloudsaas.com/state/F");
      } else if (index === 7) {
        window.open("http://gathercloudsaas.com/state/G");
      } else if (index === 8) {
        window.open("http://gathercloudsaas.com/state/H");
      } else if (index === 9) {
        window.open("http://gathercloudsaas.com/state/I");
      } else if (index === 10) {
        window.open("http://gathercloudsaas.com/state/J");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.state {
  width: 100%;
  z-index: 2;
  .bannder {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      margin: 0 auto;
    }
  }
  .container2 {
    width: 1000px;
  }
  .pageh1 {
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
    margin-bottom: 45px;
  }
  .chakan {
    font-size: 14px;
    cursor: pointer;
    color: #333;
    line-height: 30px;
  }
  .panel-heading {
    font-weight: 600;
    font-size: 18px;
    color: #333;
    line-height: 28px;
    span {
      float: right;
    }
  }
  .panel-body {
    font-size: 14px;
    color: #666;
    line-height: 30px;
  }
}
.over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>


